<template>
  <table class="custom-table">
    <slot>

    </slot>
  </table>
</template>

<script>
export default {
  name: "CustomTable.vue"
}
</script>

<style lang="scss">
@import "~@/_default.scss";
table.custom-table.rounded {
  th:first-of-type {
    border-radius: $spacing-xxs 0 0 0;
  }
  th:last-of-type {
    border-radius: 0 $spacing-xxs 0 0;
  }
  tr:last-of-type {
    td:first-of-type {
      border-radius: 0 0 0 $spacing-xxs;
    }
    td:last-of-type {
      border-radius: 0 0 $spacing-xxs 0;
    }
  }
}

table.custom-table {
  table-layout: fixed;
  width: 100%;
  line-height: 1.428571429;
  font-weight: 300 ;

  tbody tr:nth-child(odd) > td, th {
    background-color: white;
  }

  tbody tr:nth-child(even) > td, th {
    background-color: $main-content-bg-color;
    &.pulse {
      animation: table-pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;

      @keyframes table-pulse {
        0%, 100% {
          background-color: rgba($main-content-bg-color, 1);
        }
        50% {
          background-color: rgba($main-content-bg-color, .2);
        }
      }
    }
  }

  th {
    color: $brand-primary;
    font-weight: 500;
    background-color: rgba(8, 85, 206, 0.25);
  }
  th:last-of-type {
    width: 1%;
    white-space: nowrap;
    box-sizing: content-box;
  }

  th, td {
    padding-top: $spacing-xs;
    padding-bottom: $spacing-xs;
    font-size: $font-size-base;
    overflow-x: clip;
    padding-left: $spacing-xxs;
    padding-right: $spacing-xxs;
    &:first-of-type {
      padding-left: $spacing-lg;
    }

    &:last-of-type {
      padding-right: $spacing-lg;
    }
  }
  .ant-checkbox {
    padding: 0;
  }
}
</style>
